import React, { useEffect, useState } from 'react';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { IModal } from './Gallery';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Fetch, baseUrl } from '../../shared/Fetch';
import { format } from 'date-fns';
import { ILogin, IPermissionProps } from '../../models/Login';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { safeFormatDate } from '../../models/DateFormatMapper';

interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    permissions: IPermissionProps,
}

export interface IGallery {
    iD?: number,
    id?: number,
    title?: string,
    description?: string,
    status?: boolean,

}
export interface Video {
    id?: string;
    title?: string;
    url?: string;
    status?: boolean;
}
export const IEmpty = {
    iD: 0,
    title: '',
    description: '',
    status: false,
}

export default function Table(props: Iprops) {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IGallery>, loading: boolean });

    const [videos, setVideos] = useState<Video[]>([]);
    const [error, setError] = useState<string | null>(null);
    const leftToolbarTemplate = () => {
        return (
            <div className="my-2">
                <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
            </div>
        );
    }

    const openNew = () => {
        props.setModal({ singleData: IEmpty, open: true });
    }

    const RemoveVideo = async (rowData: IGallery) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Video_Gallery", "DELETE", null, `ID=${rowData.id}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: " Video Removed", life: 3000 });
            loadData();
        }
    }
    const rejectFunc = () => {
        props.toast.current.show({ severity: "error", detail: "You have Canceled", life: 3000 })

    }
    const confirmDelete = (rowData: IGallery) => {
        confirmDialog({
            message: `Are you sure you want to delete this Video`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            // defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            accept: () => RemoveVideo(rowData),
            reject: () => rejectFunc()
        });
    }

    const action = (rowData: any) => {
        return (
            <div className="flex gap-3">
                <Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button>
                <Button className="pi pi-trash  bg-white border-none" style={{ backgroundColor: 'white', borderColor: 'red', color: 'red' }} onClick={() => { confirmDelete(rowData) }} ></Button>
            </div>
        );
    }

    const openEdit = (rowData: IGallery) => {
        props.setModal({ singleData: rowData, open: true });
    };



    const loadData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Video_Gallery", "GET", null, null, props.toast);
        if (response) {
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    }
    const pDate = (rowData: any) => {
        let date;
        if (rowData.created_at) date = format(new Date(rowData.created_at), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const toggleVal = async (id: number | IGallery, toggle_type: number) => {
        const response = await Fetch("Video_Gallery/togglestatus", "PUT", null, `ID=${id}&toggle_type=${toggle_type}`, props.toast);
        if (response) {
            let message: string = "Status Changed";
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            loadData();
        }
    };

    const user_TStatus = (rowData: any) => {
        return (
            <span style={{ color: rowData.status ? 'green' : 'red' }} className="cursor-pointer" onClick={() => { toggleVal(rowData.id, 1) }}>{rowData.status ? "Active" : "InActive"}</span>
        );

    };

    useEffect(() => {
        loadData();
    }, [props.reload]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj?.date_Format;
    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small" stripedRows scrollable scrollHeight="75vh"
                resizableColumns showGridlines columnResizeMode="expand"
                emptyMessage="No Requirements found."
                value={tableData.tableData}
            >
                {/* <Column header="SN." body={(data, options) => options.rowIndex + 1} /> */}
                <Column field="title" header="Title" />
                <Column field="description" header="Description" />
                <Column field="" header="Status " style={{ maxWidth: "20rem" }} body={user_TStatus} />
                {/* <Column field="created_at" header="Posted On" body={pDate} sortable /> */}
                 <Column field="created_at" header="Posted On" body={(rowData : any) => safeFormatDate(rowData.created_at, "dd/MM/yyyy", DateFormat)} sortable />
                <Column field="" header="Action" body={action} />
            </DataTable>
            <ConfirmDialog />

        </>
    )
}
